import styled from 'styled-components';

export const ConferenceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  height: auto;
  min-height: 400px;
  max-height: calc(100vh - 48px);
  background: #111827;
  color: white;
  max-width: 1200px;
  margin: 24px auto;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgb(0 0 0 / 0.2);
  backdrop-filter: blur(8px);
  position: relative;

  .murphy-status {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(8px);
    padding: 12px 20px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;

    .loading-icon {
      color: #60A5FA;
      font-size: 1.1rem;
    }

    .status-content .status-message a {
      color: #60A5FA;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  /* Murphy warning animation */
  @keyframes pulse {
    0% { 
      transform: scale(1); 
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7); 
    }
    50% { 
      transform: scale(1.02); 
      box-shadow: 0 0 0 10px rgba(255, 152, 0, 0.3); 
    }
    100% { 
      transform: scale(1); 
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0); 
    }
  }
`;
